module.exports = __webpack_public_path__ + "img/bgImg.6a301947.png";